export enum OrderQueryField {
  // ---------- ORDERS ----------
  id = 'id',
  externalId = 'externalId',
  orderCreationDate = 'orderCreationDate',
  orderVolume = 'orderVolume',
  // ---------- CONTRACT ----------
  contractCreationDate = 'contractCreationDate',
  contractReceivedProposalsCount = 'contractReceivedProposalsCount',
  contractAverageValueContribution = 'contractAverageValueContribution',
  // ---------- SUPPLIER ----------
  supplierId = 'supplierId',
  supplierExternalId = 'supplierExternalId',
  supplierName = 'supplierName',
  supplierEmployeeCount = 'supplierEmployeeCount',
  supplierIndustry = 'supplierIndustry',
  supplierLegalType = 'supplierLegalType',
  // ---------- LOCATION ----------
  supplierAddressCountry = 'supplierAddressCountry',
  supplierAddressCity = 'supplierAddressCity',
  supplierLocationRadius = 'supplierLocationRadius',
  // ---------- PRODUCTS ----------
  productId = 'productId',
  productName = 'productName',
  productExternalId = 'productExternalId',
  productCategory = 'productCategory',
  // ---------- SERVICES ----------
  serviceId = 'serviceId',
  serviceName = 'serviceName',
  serviceExternalId = 'serviceExternalId',
  serviceCategory = 'serviceCategory',
  // ---------- COMMODITY GROUP ----------
  primaryCommodityGroupId = 'primaryCommodityGroupId',
  commodityGroup = 'commodityGroup',
  // ---------- SOURCE SYSTEM ----------
  sourceSystemName = 'sourceSystemName',
}

export enum OrderQueryFieldGroup {
  contract = 'contract',
  supplier = 'supplier',
  performance = 'performance',
  product = 'product',
  service = 'service',
  order = 'order',
  location = 'location',
  sourceSystem = 'sourceSystem',
  commodityGroup = 'commodityGroup',
}
